import React from "react";

import styles from "./phoneme.module.css";
import { displayLetter } from "../../util/Util";
interface Props {
  phonics: string;
  style?: any;
  id?: string;
}

const PhonicsCard = (props: Props) => {
  const { style, id } = props;

  let { phonics } = props;
  phonics = displayLetter(phonics);

  return (
    <div className={styles.phonicsCardWrapper} style={style} id={id}>
      <div className={styles.phonicsCard}>{phonics}</div>
    </div>
  );
};

export default PhonicsCard;
